module.exports = __webpack_public_path__ + "img/logos_partner_16.d19c860a.svg";